import { enums } from '~/util/enums/enums';

const USER_EXTERNAL_ACCOUNT_TYPE_CORE_APP = 1;
const USER_EXTERNAL_ACCOUNT_TYPE_OHID = 2;

interface PendoVisitor {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    title: string;
    role: string;
    access_type: string;
    is_linked_to_lr: boolean;
    is_linked_to_ohid: boolean;
    is_active: boolean;
}

interface PendoSDK {
    identify: (options: { visitor: PendoVisitor }) => void;
}

declare global {
    interface Window {
        pendo?: PendoSDK;
    }
}

export function buildPendoIdentifyPayload(user: UserType): { visitor: PendoVisitor } {
    const externalAccounts = user.user_external_accounts ?? [];

    return {
        visitor: {
            // Use email as visitor id to dedup MAU across Core and Zephyr.
            id: user.email,
            email: user.email,
            first_name: user.first_name,
            last_name: user.last_name,
            title: user.title,
            role: user.roles?.join(', ') ?? '',
            access_type: enums(['user', 'access_type', user.access_type]) ?? '',
            is_linked_to_lr: externalAccounts.some(
                (account) => account.type === USER_EXTERNAL_ACCOUNT_TYPE_CORE_APP
            ),
            is_linked_to_ohid: externalAccounts.some(
                (account) => account.type === USER_EXTERNAL_ACCOUNT_TYPE_OHID
            ),
            is_active: Boolean(user.enabled_at),
        },
    };
}

export function initializePendo(user: UserType | null | undefined): void {
    if (!user || !window.pendo) {
        return;
    }
    window.pendo.identify(buildPendoIdentifyPayload(user));
}
